import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
const btnTheme = {};
for (const item of Object.keys(brandCodeMap)) {
  btnTheme[item] = {
    btn: {
      bgColor: base[item]?.btnColor.c0002,
      color: comm.color.cffff,
      hoverColor: base[item]?.btnColor.c0041,
      disabledColor: base[item]?.btnColor.c0024,
      disabledBg: base[item]?.btnColor.c0042,
    },
  };
}

export const btn = btnTheme;
